export default {"src":"/_next/static/media/amex-light.8d97c7cc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};